import React, { FC } from 'react'

interface CardWhyStudyInAccelistProps {
    title: string
    subtitle: string
    imageSrc: string
}

const CardWhyStudyInAccelist: FC<CardWhyStudyInAccelistProps> = ({ title, subtitle, imageSrc }) => {

    return (
        <div className='relative w-full min-w-0 px-4 py-4 text-center mt-8 sm:mt-12'>
            <img src={imageSrc} alt="image.png" className='mx-auto h-24' />
            <h5 className='mt-5 text-accent-100 text-xl font-body font-bold min-h-[40px]'>{title}</h5>
            <p className='text-main-100 text-sm font-body md:text-justify font-normal mt-2 md:mt-0'>{subtitle}</p>
        </div>
    )
}


export default CardWhyStudyInAccelist
